import { useSelector } from "react-redux";
import { selectBusiness } from "./businessSlice";

export const useBusiness = () => {
  const { body, updating } = useSelector(selectBusiness)
  
  return {
    body,
    updating,
  }
}
